// import axios from 'axios'

import userACL from "../store/access";

/* const axios = axios.create({
    baseURL: 'http://3.7.148.233/' ,

    headers: {'Authorization': `Bearer ${localStorage.getItem('user')}`, 'Content-Type' : 'application/json'}//here we add header to each request
    }) */

// export default axios;

/* const apiContainer = {
    axios : axios.create({
        baseURL: 'http://3.7.148.233/' ,
        headers: {'Authorization': `Bearer ${localStorage.getItem('user')}`, 'Content-Type' : 'application/json'}//here we add header to each request
    })
}

export const setApi = () => {
    console.log(' Setting api again ')
    apiContainer.axios = axios.create({
        baseURL: 'http://3.7.148.233/' ,
        headers: {'Authorization': `Bearer ${localStorage.getItem('user')}`, 'Content-Type' : 'application/json'}//here we add header to each request
    })
} */

export const getHeaderJWT = () => {
    return {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
        },
    };
};

// export default apiContainer;

//TODO: Implement Nginx Proxy
// export const URL_NOTIFICATION = 'http://3.7.148.233:8888/notification'
// export const URL_GOAL = 'http://3.7.148.233/goals'
// export const URL_MEETINGS = 'http://3.7.148.233/meetings'
// export const URL_ORGANISATION = 'http://3.7.148.233/organisation'
// export const URL_TASKS = 'http://3.7.148.233/tasks'
// export const URL_USERS = 'http://3.7.148.233/users'
// export const URL = 'http://3.7.148.233'

export const URL_NOTIFICATION = "http://35.154.106.204:8888/notification";
export const URL_GOAL = "http://35.154.106.204/goals";
export const URL_MEETINGS = "http://35.154.106.204/meetings";
export const URL_ORGANISATION = "http://35.154.106.204/organisation";
export const URL_TASKS = "http://35.154.106.204/tasks";
export const URL_USERS = "http://35.154.106.204/users";
export const URL = "http://35.154.106.204";

export const getRlbUrl = () => {
    let url = window.location.href;
    // console.log(url, "-----------url-1");
    url = url.split("/AMS-war/")[0];
    // console.log(url, "-----------url-2");
    return url;
};

// export const URL_NOTIFICATION = 'http://localhost:8888/notification'
// export const URL_GOAL = 'http://localhost/goals'
// export const URL_MEETINGS = 'http://localhost/meetings'
// export const URL_ORGANISATION = 'http://localhost/organisation'
// export const URL_TASKS = 'http://localhost/tasks'
// export const URL_USERS = 'http://localhost/users'
// export const URL = 'http://localhost'

// export const getHeader = () => { return{ headers : {'boxId': `RLBMBOX101`, 'Content-Type' : 'application/json'}}}

export const getHeader = () => {
    let fetchData = userACL.atFetch(),
        boxId = fetchData.boxId,
        d = new Date(),
        curr_day = d.getDate()<10?"0"+d.getDate():d.getDate(),
        curr_mnth = parseInt(d.getMonth(),10)+ parseInt(1),
        curr_year = d.getFullYear(),
        curFormattedDate= curr_year+""+(curr_mnth<10?"0"+curr_mnth:curr_mnth)+""+curr_day;
    return {
        headers: {
            "boxId": boxId,
            "Content-Type": "application/json",
            "crossDomain": true,
            "withCredentials": true,
            // "X-RLB-SERVICE-KEY":"SADFERIDSVNDFJERUGSDFLASN",
            // "X-RLB-SECRET-KEY":"ssjdurydnx#$dfmdfkadasdoiury",
            // "X-RLB-SERVICE-KEY":"C3576REAODFODROAJCND",
            // "X-RLB-SECRET-KEY":"asdjherodndcbchapirueirjaksld",
            "X-RLB-SERVICE-TIME":"RLB_"+curFormattedDate
        },
    };
};


export const URL_RLB = getRlbUrl() + "/service"
// export const URL_RLB = "http://43.204.150.85:5009"
// export const URL_RLB = "http://localhost"